import React from 'react';

import ActionButton from 'jbc-front/components/ActionButton';
import Storage from 'jbc-front/components/icons/Strage';
import { useTranslation } from 'react-i18next';

const SaveActionBtn = props => {
  const { t } = useTranslation();
  const { onClick, label = t('buttons.ActionBtn.SaveActionBtn.Save'), as, ...rest } = props;
  return (
    <ActionButton as={as || 'button'} icon={<Storage />} onClick={onClick} {...rest}>
      {label}
    </ActionButton>
  );
};

export default SaveActionBtn;
